// (A) 중립 Empty API — antd 미접촉. (B) PlainEmpty 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainEmpty } from '../_impl/PlainEmpty'

export interface OmwEmptyProps {
  /** 실측: utils/ui 빈상태가 image/description/imageStyle 사용. */
  image?: ReactNode
  description?: ReactNode
  /** antd 의 styles.image 슬롯으로 매핑(어댑터 내부 처리). */
  imageStyle?: CSSProperties
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwEmpty(props: OmwEmptyProps) {
  return <PlainEmpty {...props} />
}
